import React, { useState, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Card, Form, Button, Badge, Table } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";

export default function GastosReportesPage() {
    const { t } = useContext(TranslatorContext);
    
    const [filtros, setFiltros] = useState({
        fechaInicio: '',
        fechaFin: '',
        categoria: '',
        responsable: '',
        fondo: ''
    });

    // Datos de ejemplo para los reportes
    const resumenPorCategoria = [
        { categoria: 'Gastos Oficina', total: 2800000, porcentaje: 35, color: '#dc3545', items: 15 },
        { categoria: 'Edmundo Neira', total: 1200000, porcentaje: 15, color: '#0dcaf0', items: 8 },
        { categoria: 'Operativa/Terreno', total: 2500000, porcentaje: 31, color: '#198754', items: 12 },
        { categoria: 'Egresos Operativos', total: 1500000, porcentaje: 19, color: '#ffc107', items: 10 }
    ];

    const gastosRecurrentes = [
        { concepto: 'Arriendo', monto: 450000, frecuencia: 'Mensual', ultimoPago: '2024-07-01' },
        { concepto: 'Sueldo Contador', monto: 350000, frecuencia: 'Mensual', ultimoPago: '2024-07-01' },
        { concepto: 'Plan Internet/Teléfono', monto: 45000, frecuencia: 'Mensual', ultimoPago: '2024-06-25' },
        { concepto: 'Seguro vehículo', monto: 85000, frecuencia: 'Mensual', ultimoPago: '2024-06-30' }
    ];

    const alertas = [
        { tipo: 'warning', mensaje: 'Fondo Capacidad Laboral al 85% de ejecución' },
        { tipo: 'danger', mensaje: 'Presupuesto Gastos Oficina excedido en 5%' },
        { tipo: 'info', mensaje: '3 gastos pendientes de aprobación' }
    ];

    const floats = [
        { title: "Total Período", digit: 8000000, icon: "attach_money", variant: "lg blue" },
        { title: "Promedio Mensual", digit: 1333333, icon: "trending_up", variant: "lg green" },
        { title: "Gastos Aprobados", digit: 42, icon: "check_circle", variant: "lg purple" },
        { title: "Pendientes", digit: 8, icon: "pending", variant: "lg orange" }
    ];

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0
        }).format(amount);
    };

    const handleFiltroChange = (e) => {
        setFiltros(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const aplicarFiltros = () => {
        // Aquí iría la lógica para aplicar los filtros
        console.log('Aplicando filtros:', filtros);
    };

    const exportarReporte = (formato) => {
        // Aquí iría la lógica para exportar el reporte
        console.log('Exportando reporte en formato:', formato);
    };

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Reportes de Gastos</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='/gastos' className="mc-breadcrumb-link">Gastos</Link></li>
                                <li className="mc-breadcrumb-item">Reportes</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                {/* Filtros */}
                <Col xl={12}>
                    <Card className="mc-card mb-4">
                        <Card.Header>
                            <h5>Filtros de Búsqueda</h5>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fecha Inicio</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="fechaInicio"
                                            value={filtros.fechaInicio}
                                            onChange={handleFiltroChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fecha Fin</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="fechaFin"
                                            value={filtros.fechaFin}
                                            onChange={handleFiltroChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Categoría</Form.Label>
                                        <Form.Select
                                            name="categoria"
                                            value={filtros.categoria}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">Todas</option>
                                            <option value="gastos_oficina">Gastos Oficina</option>
                                            <option value="edmundo_neira">Edmundo Neira</option>
                                            <option value="operativa_terreno">Operativa/Terreno</option>
                                            <option value="egresos_operativos">Egresos Operativos</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Responsable</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="responsable"
                                            value={filtros.responsable}
                                            onChange={handleFiltroChange}
                                            placeholder="Nombre..."
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Fondo</Form.Label>
                                        <Form.Select
                                            name="fondo"
                                            value={filtros.fondo}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">Todos</option>
                                            <option value="emergencia">Fondo Emergencia</option>
                                            <option value="inversion">Fondo Inversión</option>
                                            <option value="capitalizacion">Fondo Capitalización</option>
                                            <option value="laboral">Fondo Capacidad Laboral</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={2} className="d-flex align-items-end">
                                    <Button variant="primary" onClick={aplicarFiltros} className="me-2">
                                        Filtrar
                                    </Button>
                                    <Button variant="outline-secondary" onClick={() => setFiltros({fechaInicio: '', fechaFin: '', categoria: '', responsable: '', fondo: ''})}>
                                        Limpiar
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Cards de resumen */}
                {floats.map((float, index) => (
                    <Col key={index} sm={6} lg={3}>
                        <FloatCardComponent 
                            variant={float.variant}
                            digit={formatCurrency(float.digit)}
                            title={float.title}
                            icon={float.icon}
                        />
                    </Col>
                ))}

                {/* Alertas */}
                <Col xl={12}>
                    <Card className="mc-card mb-4">
                        <Card.Header>
                            <h5>Alertas y Notificaciones</h5>
                        </Card.Header>
                        <Card.Body>
                            {alertas.map((alerta, index) => (
                                <div key={index} className={`alert alert-${alerta.tipo} mb-2`} role="alert">
                                    <i className="material-icons me-2">
                                        {alerta.tipo === 'warning' ? 'warning' : alerta.tipo === 'danger' ? 'error' : 'info'}
                                    </i>
                                    {alerta.mensaje}
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>

                {/* Resumen por categoría */}
                <Col md={8}>
                    <Card className="mc-card">
                        <Card.Header>
                            <h5>Gastos por Categoría</h5>
                        </Card.Header>
                        <Card.Body>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Categoría</th>
                                        <th>Total</th>
                                        <th>% del Total</th>
                                        <th>Cantidad</th>
                                        <th>Promedio</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resumenPorCategoria.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div 
                                                        className="me-2" 
                                                        style={{
                                                            width: '12px',
                                                            height: '12px',
                                                            backgroundColor: item.color,
                                                            borderRadius: '2px'
                                                        }}
                                                    ></div>
                                                    {item.categoria}
                                                </div>
                                            </td>
                                            <td style={{ color: item.color, fontWeight: 'bold' }}>
                                                {formatCurrency(item.total)}
                                            </td>
                                            <td>
                                                <Badge bg="secondary">{item.porcentaje}%</Badge>
                                            </td>
                                            <td>{item.items}</td>
                                            <td>{formatCurrency(item.total / item.items)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Gastos recurrentes */}
                <Col md={4}>
                    <Card className="mc-card">
                        <Card.Header>
                            <h5>Gastos Recurrentes</h5>
                        </Card.Header>
                        <Card.Body>
                            {gastosRecurrentes.map((gasto, index) => (
                                <div key={index} className="mb-3 p-3 border rounded">
                                    <h6 className="mb-1">{gasto.concepto}</h6>
                                    <div className="d-flex justify-content-between">
                                        <span className="text-primary fw-bold">{formatCurrency(gasto.monto)}</span>
                                        <Badge bg="info">{gasto.frecuencia}</Badge>
                                    </div>
                                    <small className="text-muted">
                                        Último pago: {new Date(gasto.ultimoPago).toLocaleDateString('es-CL')}
                                    </small>
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>

                {/* Acciones de exportación */}
                <Col xl={12}>
                    <Card className="mc-card">
                        <Card.Header>
                            <h5>Exportar Reportes</h5>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={3}>
                                    <Button 
                                        variant="success" 
                                        className="w-100 mb-2"
                                        onClick={() => exportarReporte('excel')}
                                    >
                                        <i className="material-icons me-2">table_chart</i>
                                        Exportar Excel
                                    </Button>
                                </Col>
                                <Col md={3}>
                                    <Button 
                                        variant="danger" 
                                        className="w-100 mb-2"
                                        onClick={() => exportarReporte('pdf')}
                                    >
                                        <i className="material-icons me-2">picture_as_pdf</i>
                                        Exportar PDF
                                    </Button>
                                </Col>
                                <Col md={3}>
                                    <Button 
                                        variant="info" 
                                        className="w-100 mb-2"
                                        onClick={() => exportarReporte('csv')}
                                    >
                                        <i className="material-icons me-2">description</i>
                                        Exportar CSV
                                    </Button>
                                </Col>
                                <Col md={3}>
                                    <Button 
                                        variant="secondary" 
                                        className="w-100 mb-2"
                                        onClick={() => window.print()}
                                    >
                                        <i className="material-icons me-2">print</i>
                                        Imprimir
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}
